import React from 'react';
import {Text, Loader} from '@gravity-ui/uikit';
import {PropertyRow, formatDateTimeToLocal, formatCurrency} from '../../../../../shared';
import {BenefactorSubscriptionModel} from '../../../model';
import styles from './ActiveSubscriptions.module.scss';

interface ActiveSubscriptionsProps {
  subscriptions: BenefactorSubscriptionModel[];
  isLoading: boolean;
}

export const ActiveSubscriptions: React.FC<ActiveSubscriptionsProps> = ({subscriptions, isLoading}) => {
  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <Loader size="m" />
      </div>
    );
  }

  if (subscriptions.length === 0) {
    return (
      <div className={styles.emptyContainer}>
        <Text variant="body-1" color="secondary">
          Нет действующих подписок
        </Text>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Text variant="subheader-3" className={styles.title}>
        Действующие подписки
      </Text>

      <div className={styles.subscriptionsList}>
        {subscriptions.map((subscription) => (
          <>
            <PropertyRow
              property="Дата создания"
              value={formatDateTimeToLocal(subscription.createdAt)}
              className={styles.propertyRow}
            />
            <PropertyRow property="Сумма" value={formatCurrency(subscription.amount)} className={styles.propertyRow} />
            <PropertyRow
              property="Дата последнего списания"
              className={styles.propertyRow}
              value={subscription.lastChargedAt ? formatDateTimeToLocal(subscription.lastChargedAt) : '-'}
            />
            <PropertyRow
              property="Дата неуспешного списания"
              value={subscription.lastFailedAttemptAt ? formatDateTimeToLocal(subscription.lastFailedAttemptAt) : '-'}
              className={styles.propertyRow}
            />
            <PropertyRow
              property="Кол-во неуспешных попыток"
              value={subscription.numberOfFailedAttempts?.toString() || '-'}
              className={styles.propertyRow}
            />
          </>
        ))}
      </div>
    </div>
  );
};
